<template>
  <div>
    <v-container class="my-7">
      <banner type="top" />
      <v-row>
        <v-col cols="12" md="8" class="mt-6 pr-lg-8">
          <section class="article">
            <article-item type="articles" />
          </section>
        </v-col>

        <v-col md="4" class="mt-6">
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <!-- <banner type="right-a" class="mt-4" w="100%" h="null" /> -->
              <banner-video class="mt-4" />

              <most-read class="mt-6" />
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <banner type="right-b" class="mt-4" w="100%" h="null" />

              <schedule class="mt-6" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <banner type="center-2" class="mt-12" />
    </v-container>
  </div>
</template>

<script>
import ArticleItem from "@/components/widgets/Article.vue";
import Banner from "@/components/cards/Banner.vue";
import MostRead from "@/components/widgets/MostRead.vue";
import Schedule from "@/components/widgets/Schedule.vue";

export default {
  data: () => ({
    loading: true,
  }),
  components: {
    Banner,
    ArticleItem,
    MostRead,
    Schedule,
  },
};
</script>
